import { useMemo } from "react";
import { CalendarDays, ChevronDown } from "lucide-react";
import { monthKey, monthLabel } from "./pipelineUtils";

// Monatsauswahl „Alle Zeiträume / Oktober 2026 (n)“ – nur Monate, in denen es Angebote/Unterschriften gibt.
export function MonthSelect({ projects, value, onChange }) {
  const months = useMemo(() => {
    const m = new Map();
    (projects || []).forEach((p) => {
      const k = monthKey(p);
      if (k) m.set(k, (m.get(k) || 0) + 1);
    });
    return [...m.entries()].sort((a, b) => (a[0] < b[0] ? 1 : -1));
  }, [projects]);
  if (!months.length) return null;
  const on = !!value;
  return (
    <div className="relative" data-testid="pipeline-month-filter">
      <CalendarDays size={13} className={`absolute left-2.5 top-1/2 -translate-y-1/2 pointer-events-none ${on ? "text-[#09090B]" : "text-zinc-400"}`} />
      <select
        value={value}
        onChange={(e) => { onChange(e.target.value); e.target.blur(); }}
        data-testid="pipeline-month-select"
        style={{ backgroundImage: "none" }}
        aria-label="Monat auswählen"
        className={`input-raw h-7 pl-7 pr-7 rounded-full text-[11.5px] font-semibold border appearance-none cursor-pointer transition-colors focus:outline-none ${
          on ? "bg-[#00E575] text-[#09090B] border-[#00E575]" : "bg-transparent text-zinc-300 border-zinc-700 hover:border-zinc-500"
        }`}
      >
        <option value="">Alle Zeiträume</option>
        {months.map(([k, n]) => (
          <option key={k} value={k} data-testid={`pipeline-month-option-${k}`}>{monthLabel(k)} ({n})</option>
        ))}
      </select>
      <ChevronDown size={13} className={`absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none ${on ? "text-[#09090B]" : "text-zinc-400"}`} />
    </div>
  );
}
